import { AsyncCombobox } from 'compositions/AsyncCombobox'
import { useLayout } from 'hooks/api'
import { useAsyncLoader } from 'hooks/useAsyncLoader'
import { useMemo } from 'react'
import type { Layout } from 'types/layouts'

export function LayoutSelector({
  value,
  onChange,
}: {
  value: string | null
  onChange: (layoutId: string | null) => void
}) {
  const load = useAsyncLoader<Layout>('/api/layouts')
  const { data: selectedLayout } = useLayout(value ?? undefined)

  const selected = useMemo<Layout | null>(() => {
    if (!value) {
      return null
    }
    return selectedLayout?.id === value ? selectedLayout : null
  }, [value, selectedLayout])

  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-muted-foreground">Layout</label>
      <AsyncCombobox<Layout>
        value={selected}
        onChange={(item) => onChange(item?.id ?? null)}
        load={load}
        getKey={(item) => item.id}
        getLabel={(item) => item.name}
        placeholder="No layout"
        searchPlaceholder="Search layouts…"
        clearable
        clearLabel="No layout"
      />
    </div>
  )
}
